export default __webpack_public_path__ + "dbb0c68888cddc5b9e902e20eba31c43.png";